import { USERS_BASE_URL } from "../config";
import type { User } from "../types/chat";

export interface GetUserProfileResponse {
  user: User | null;
  error: string | null;
}

/**
 * Fetches user profile by agent ID
 * @param agentId - The agent/user ID to fetch
 * @returns Promise with user data or error message
 */
export async function getUserProfile(
  agentId: string
): Promise<GetUserProfileResponse> {
  try {
    const res = await fetch(
      `${USERS_BASE_URL}/public/get-user-profile/${agentId}`
    );
    
    if (res.status === 404) {
      return {
        user: null,
        error: "We couldn't find this AI rep. Please check the AI rep id.",
      };
    }
    
    if (!res.ok) {
      return {
        user: null,
        error: "Failed to load AI rep profile. Please try again later.",
      };
    }
    
    const user = await res.json();
    return {
      user,
      error: null,
    };
  } catch {
    return {
      user: null,
      error: "Network error while loading AI rep profile.",
    };
  }
}

